import { GridValidRowModel, GridValueFormatter } from '@mui/x-data-grid-pro';
import { isNil } from 'ramda';
import { Union } from 'ts-toolbelt';

import { NULLISH_CELL_VALUE } from '../DataGridCustom.types';

type JoinFormatterValue = Union.Nullable<string | Union.Nullable<string>[]>;

interface JoinFormatterFactoryOptions {
  separator?: string;
}

export const joinFormatterFactory = <R extends GridValidRowModel = any>(
  options?: JoinFormatterFactoryOptions,
): GridValueFormatter<R> => {
  return (value: JoinFormatterValue) => {
    try {
      return !isNil(value)
        ? (Array.isArray(value) ? value : [value]).join(options?.separator || ',')
        : NULLISH_CELL_VALUE;
    } catch (e) {
      console.log(e);
    }
    return NULLISH_CELL_VALUE;
  };
};
